import React, { FC } from 'react';
import { useTranslation } from '../../../tools/i18n';
import { Picto } from '../../Picto';

interface NightDayHeaderDayProps {
  dayIndex?: number;
  spotName?: string;
  spot?: any;
  date?: string;
  onSpotClick?: (spot: any) => void;
}

const NightDayHeaderDay: FC<NightDayHeaderDayProps> = ({
  dayIndex,
  spotName,
  spot,
  date,
  onSpotClick,
}) => {
  const { t } = useTranslation();
  const canOpenDetail = !!spotName && !!spot && !!onSpotClick;

  return (
    <div className="NightDayHeaderDay" id={`${t('travelPlaner.Travel.day')}${dayIndex || ''}`}>
      <Picto iconKey="itinerary-fr" width="40" height="40" />
      <div className="NightDayHeaderDayContent">
        {spotName ? (
          <h3>
            {canOpenDetail ? (
              <button
                type="button"
                className="NightDayHeaderDaySpotButton"
                onClick={() => onSpotClick?.(spot)}
              >
                {spotName}
              </button>
            ) : (
              <span>{spotName}</span>
            )}
          </h3>
        ) : (
          <span>{`${t('travelPlaner.Travel.day')} ${dayIndex || ''}`}</span>
        )}
        {date ? <span className="NightDayHeaderDayDate">{date}</span> : null}
      </div>
    </div>
  );
};

export default NightDayHeaderDay;
